import { render, staticRenderFns } from "./SetConfigRoleInput.vue?vue&type=template&id=63df7a94&scoped=true"
import script from "./SetConfigRoleInput.vue?vue&type=script&lang=js"
export * from "./SetConfigRoleInput.vue?vue&type=script&lang=js"
import style0 from "./SetConfigRoleInput.vue?vue&type=style&index=0&id=63df7a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df7a94",
  null
  
)

export default component.exports